import { Grid } from '@chakra-ui/react';
import { OfficeTeasers as Props } from '../../types';
import OfficeTeaser from '../OfficeTeaser';

const OfficesTeaser = ({ offices }: Props) => (
  <Grid
    gridTemplateColumns={[
      'repeat(auto-fit, minmax(250px, 1fr))',
      null,
      'repeat(auto-fit, minmax(400px, 1fr))',
    ]}
    gridGap={[4, 6, 10]}
    as="section"
    data-test-id="section-office-teasers"
  >
    {offices?.map((office) => (
      <OfficeTeaser
        {...office}
        key={office.title}
        as="article"
        maxWidth="650px"
      />
    ))}
  </Grid>
);

export default OfficesTeaser;
